export enum ApprovalNotificationEventType {
  ITEM_TO_APPROVE_CREATED = 'ITEM_TO_APPROVE_CREATED',
  APPROVAL_APPROVED = 'APPROVAL_APPROVED',
  APPROVAL_REJECTED = 'APPROVAL_REJECTED',
  APPROVAL_FORWARED = 'APPROVAL_FORWARED',
}
